import NoSubscriptionsScreen from './NoSubscriptionsScreen';

export default NoSubscriptionsScreen;